import TramesSaisiesController from './trames.saisies.controller';

export default {
    template: require('./trames.saisies.tpl.html'),
    controller: TramesSaisiesController
};
